// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__2cLBF","header":"ReportDetails_header__22WTs","title":"ReportDetails_title__WYYDb","left":"ReportDetails_left__3KRpp"};